import type { CatalogueType } from '@/config/types'
import type { SiteName } from '@/scopes/common/domain/types'
import type { IconGlyph } from '@sunwebgroup/ui-components'

export function getCatalogues(siteName: SiteName): CatalogueType[] {
  if (siteName === 'sunwebuk' || siteName === 'sunwebde') {
    return ['winter']
  }

  if (siteName === 'sunwebfr') {
    return ['winter', 'summer']
  }

  return ['summer', 'winter']
}

export function getExtraCatalogueIcon(siteName: SiteName): IconGlyph | null {
  if (siteName === 'sunwebse' || siteName === 'sunwebdk') {
    return 'IconAirplaneRight'
  }
  return null
}
